import React, { useState, useEffect } from 'react';
import cssClasses from './RejectionReasonModal.module.css';
import { Box, IconButton, Modal, TextareaAutosize, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Button from '../../../../Subcomponents/Button';
import { makeStyles } from '@mui/styles';

function RejectionReasonModal({open, handleClose}) {

  const classList = useStyles();
  const [rejectionReasonMessage, setRejectionReasonMessage] = useState("");
  const [rejectionReasonMessageHelperText, setRejectionReasonMessageHelperText] = useState("");

  function submitHandler() {
    if(!rejectionReasonMessage) {
      setRejectionReasonMessageHelperText("Please enter rejection reason.");
      return;
    }

    handleClose({message: rejectionReasonMessage});
  }

  return (
    <Modal
      open={open}
      onClose={() => handleClose({flag: false})}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root":{
            background: "rgba(193, 201, 210, 0.7)"
          }
        }
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.header}>
          {/* <img src={MessageIcon} alt="" /> */}
          <h1>Enter Rejection reason message <sup style={{ color: "red", fontSize: "1.2rem" }}>*</sup></h1>
          {/* <img src={crossImage} alt="" style={{cursor:"pointer"}} onClick={handleClose}/> */}
          <IconButton className={cssClasses.crossButton} onClick={() => handleClose({flag: false})}> <CloseIcon /> </IconButton>
        </div>

        <div className={cssClasses.mainContainer}>
          <TextareaAutosize
            value={rejectionReasonMessage}
            className={classList.TextAreaStyle}
            minRows={2}
            placeholder="Enter a reason..."
            onChange={(e) => {
              setRejectionReasonMessage(e.target.value);
              if(e.target.value) {
                setRejectionReasonMessageHelperText("");
              } else {
                setRejectionReasonMessageHelperText("Please enter rejection reason.");
              }
            }}
          />
          { rejectionReasonMessageHelperText &&
            <Typography sx={{...helperText}}> {rejectionReasonMessageHelperText} </Typography>
          }
        </div>

        <div className={cssClasses.footer}>
          {/* <div><Button style={{ color: "#7F56D9", backgroundColor: "#ffffff" }} btnName={"Download PDF"} clicked={handleClose} /></div> */}
          <div><Button style={{ color: "#344054", backgroundColor: "#ffffff" }} btnName={"Cancel"} clicked={() => handleClose({flag: false})} /></div>
          <div><Button style={{ color: "#ffffff", backgroundColor: "#155EEF" }} btnName={"Reject Confirm"} clicked={() => { submitHandler() }}/></div>
        </div>
      </Box>
    </Modal>
  )
}

export default RejectionReasonModal;
// const labelStyle = {
//   fontWeight: "500",
//   fontSize: "14px",
//   lineHeight: "20px",
//   color: "#344054",
//   marginBottom: "0.8rem"
// }

const helperText = {
  fontSize: "1.4rem !important",
  margin: "0rem 0 0 0 !important",
  fontFamily: "Inter-Medium !important",
  lineHeight: "1.8rem !important",
  paddingTop: "0.5rem !important ",
  color: "#d32f2f"
};

const useStyles = makeStyles((theme) => ({
  textField: {
    width: "100%",
  },
  input: {
    fontSize: "1.4rem !important",
    marginTop: "0.6rem",
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #D0D5DD !important",
    boxSizing: "border-box",
    boxShadow: "0px 1px 2px rgb(16 24 40 / 5%)",
    borderRadius: "0.8rem",
    "&.Mui-error":{
      border: "1px solid red !important"
    },
    "& input": {
      padding: "1rem 1.4rem !important",
    },
    "&.Mui-focused": {
      // border: "unset",
      "& .MuiOutlinedInput-notchedOutline": {
        border: "1px solid #D6BBFB !important",
        boxShadow:
          "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;",
      },
    },
    "&.MuiSelect-outlined": {
      border: "1px solid #D0D5DD !important",
    },
    "& fieldSet": {
      border: "none",
    },
    "&:hover": {
      // border:"none",
      "& .MuiOutlinedInput-notchedOutline": {
        // border: '1px solid #D0D5DD !important'
      },
    },
    "& p": {
      fontSize: "1.4rem",
    },
    "&.MuiSelect-select": {
      border: "1px solid #D6BBFB !important",
    },
  },
  helperText: {
    fontSize: "1.4rem !important",
    margin: "0.2rem 0 0 0 !important",
  },
  TextAreaStyle : {
    background: "#FFFFFF",
    border: "1px solid #D0D5DD",
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "8px",
    maxWidth: "calc(100% - 2.8rem - 4px)",
    minWidth: "calc(100% - 2.8rem - 4px)",
    maxHeight: "20rem",
    minHeight: "12rem",
    padding: "1rem 1.4rem",
    fontSize: "1.8rem",
    "&:focus" : {
      outline: 'none',
      border: "1px solid #D6BBFB !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;",
    }
  }
}));